module.exports = __webpack_public_path__ + "static/LGMultiImage-a75f5ded1ef4c39c15f81bcf777c48b8.jpg";